export function formatToolLabel(tool) {
  switch (tool) {
    case 'web_search':
      return 'Web Search';
    case 'fetch_url':
      return 'Fetch URL';
    case 'search_arxiv':
      return 'arXiv Search';
    case 'search_scholar':
      return 'Scholar Search';
    case 'verify_doi':
      return 'DOI Verification';
    default:
      return tool || 'Tool';
  }
}

export function compactToolDetail(data = {}) {
  const raw = data.query || data.target || data.detail || data.tool || '';
  const clean = String(raw).replace(/\s+/g, ' ').trim();
  if (!clean) return '';
  return clean.length > 80 ? `${clean.slice(0, 77)}...` : clean;
}

export function formatToolActivityText(data = {}) {
  const toolLabel = formatToolLabel(data.tool);
  const status = data.status || 'completed';

  if (status === 'started') return `is using ${toolLabel}`;
  if (status === 'failed') return `tried ${toolLabel}, but it failed`;
  return `used ${toolLabel}`;
}

export function getToolActivityTone(status = 'completed') {
  if (status === 'failed') return '#dc2626';
  if (status === 'started') return '#F97316';
  return '#16a34a';
}
